var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCollection(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.6668 11.334V15.334C18.6668 18.0007 18.0002 18.6673 15.3335 18.6673H8.66683C6.00016 18.6673 5.3335 18.0007 5.3335 15.334V8.66732C5.3335 6.00065 6.00016 5.33398 8.66683 5.33398H9.66683C10.6668 5.33398 10.8868 5.62732 11.2668 6.13398L12.2668 7.46732C12.5202 7.80065 12.6668 8.00065 13.3335 8.00065H15.3335C18.0002 8.00065 18.6668 8.66732 18.6668 11.334Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.3335 5.33398H15.3335C16.6668 5.33398 17.3335 6.00065 17.3335 7.33398V8.25398",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollection);
export default __webpack_public_path__ + "static/media/collection.0dcf50bf414a8fc182271169ffd10a5f.svg";
export { ForwardRef as ReactComponent };